import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { environment } from "src/environments/environment";
import { CustomValidators } from "ng2-validation";
import {
  ConfirmationService,
  LazyLoadEvent,
  MessageService,
} from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "src/app/services/user.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { CareerService } from "src/app/services/career.service";
import { OpponentsService } from "src/app/services/opponents.service";
import { TournamentsService } from "src/app/services/tournamnet.service";
import * as moment from "moment";
@Component({
  selector: "app-matches",
  templateUrl: "./matches.component.html",
  styleUrls: ["./matches.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class MatchesComponent implements OnInit {
  public item;
  Historystatus: boolean = false;
  upcomingstatus: boolean = false;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: "My Title",
      fontSize: 16,
    },
    legend: {
      position: "bottom",
    },
  };
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: "1024px",
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  rankData: any;
  matchesData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  public upcommingmatchList: any = [];
  public pastMatchList: any = [];
  public totalpastMatchCount: Number = 0;
  public totalupcommingmatchCount: Number = 0;
  public showUpcomming: boolean = false;
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public searchby;
  playerName: any;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService
  ) {}
  ngOnInit(): void {
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: "#495057",
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "#495057",
          },
          grid: {
            color: "#ebedef",
          },
        },
        y: {
          ticks: {
            color: "#495057",
          },
          grid: {
            color: "#ebedef",
          },
        },
      },
    };
    this.rankData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Rank",
          data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
          fill: false,
          borderColor: "#42A5F5",
          tension: 0.4,
        },
      ],
    };
    this.matchesData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Matches",
          data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
          fill: false,
          borderColor: "#7CFC00",
          tension: 0.4,
        },
      ],
    };

    this.data = {
      // labels: ['Skill', 'Skill', 'Skill'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
        },
      ],
    };

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
      this.loadPastMatches(this.lazyLoadEvent);
      this.loadUpcomingMatches(this.lazyLoadEvent);
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(["/"]);
    }
  }

  loadUpcomingMatches(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&type=upcoming";
    var pagenumber = 1;
    var params = "";
    var rows=4;
    if (event != undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 4;
      }
    }

    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
   
    }

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    // if (event.sortField != undefined && event.sortOrder != undefined) {
    //   var orderBy = "";
    //   if (event.sortOrder == 1) {
    //     orderBy = "DESC";
    //   } else {
    //     orderBy = "ASC";
    //   }
    //   query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    // }
    /**
     * Sequence wise sort.
     **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.tournamentsService.getMatchList(this.userId, query).subscribe(
      (data) => {
        this.loading = false;
        this.matchList = [];
        this.upcommingmatchList = data["upcomingPlayerMatches"];
this.playerName=this.upcommingmatchList[0]?.playerName
        // this.totalupcommingmatchCount = this.upcommingmatchList.length;
        this.totalupcommingmatchCount = data["upcommingMatchCount"];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  loadPastMatches(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&type=past";

    var pagenumber = 1;
    var params = "";
    var rows=4;

    
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
   
    }
    if (event != undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 4;
      }
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    // if (event.sortField != undefined && event.sortOrder != undefined) {
    //   var orderBy = "";
    //   if (event.sortOrder == 1) {
    //     orderBy = "DESC";
    //   } else {
    //     orderBy = "ASC";
    //   }
    //   query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    // }
    /**
     * Sequence wise sort.
     **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }

    this.tournamentsService.getMatchList(this.userId, query).subscribe(
      (data) => {
        this.loading = false;
        this.matchList = [];
        this.pastMatchList = data["pastPlayerMatches"];
        this.totalpastMatchCount = this.pastMatchList?.length;
        this.totalRecords = data["pastMatchCount"];
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      (data) => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
        }
      },
      (err) => {}
    );
  }

  // getTournamentsList() {
  //   this.tournamentsService.getTournamentsList().then(
  //     (data) => {
  //       console.log("tournamentList", data);
  //       this.tournamentList = data;
  //     },
  //     (err) => {}
  //   );
  // }
  clickTournament() {
    this.router.navigate(["tournaments"]);
  }
  onclickTournamentdetails(tournamentid) {
    this.router.navigate(["tournaments/factsheet/" + tournamentid]);
  }
  HistoryMatch(){

    this.Historystatus = !this.Historystatus;       
};
  upcomingMatch(){

    this.upcomingstatus = !this.upcomingstatus;       
}

}
